export const dataMenu = [
    {
        id: "#home",
        path: "/",
        name: <><span>00</span><p>HOME</p></>,
    },
    {
        id: "#destination",
        path: "/destination",
        name: <><span>01</span><p>DESTINATION</p></>,
    },
    {
        id: "#crew",
        path: "/crew",
        name: <><span>02</span><p>CREW</p></>,
    },
    {
        id: "#technology",
        path: "/technology",
        name: <><span>03</span><p>TECHNOLOGY</p></>,
    }
];

export const dataHome  = [
    {
        subTitle: "So, you want to travel to",
        title: "Space",
        description: `Let’s face it; if you want to go to space, you might as well genuinely go to 
        outer space and not hover kind of on the edge of it. Well sit back, and relax 
        because we’ll give you a truly out of this world experience!`
    }
];